import { useMemo } from 'react';
import { path } from 'ramda';

import { IGameCustomFieldData } from '@core/js/hooks/games/types';
import { useGameConfigurationSelector } from '@core/js/store/hooks';

import { useDynamicTagList } from '@interlayer/js/custom/hooks/useDynamicTagList';
import { DYNAMIC_TAG_NAMES } from '@interlayer/js/custom/utils/constants';

const ALL_FEED_NAMES = 'all_feed_names';

type TGetGameInfoConfig = {
    gameInfoUrl?: IGameCustomFieldData;
    isGameInfoHidden: boolean;
}

export const useGetGameInfo = ({ code, gameFeed }: { code: string; gameFeed: string }) => {
    const gameCustomFieldsData = useGameConfigurationSelector(path(['games', code, 'gameCustomFieldsData'])) as IGameCustomFieldData[];
    const dTagFeedNamesForGameInfo = useDynamicTagList({
        tagName: DYNAMIC_TAG_NAMES.FEED_NAMES_FOR_GAME_INFO
    });

    const gameInfoUrl = useMemo(
        () => gameCustomFieldsData.find(customFieldData => customFieldData.name === 'gameInfoUrl'),
        [gameCustomFieldsData]
    );

    return useMemo((): TGetGameInfoConfig => ({
        gameInfoUrl,
        isGameInfoHidden: !dTagFeedNamesForGameInfo.includes(gameFeed) && !dTagFeedNamesForGameInfo.includes(ALL_FEED_NAMES)
    }), [dTagFeedNamesForGameInfo, gameFeed, gameInfoUrl]);
};
